var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.2,
    height: 30,
    viewBox: "0 0 26.2 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2,28.4A1.58,1.58,0,0,1,24.6,30H1.6A1.58,1.58,0,0,1,0,28.4a7.81,7.81,0,0,1,7.8-7.8H18.4A7.747,7.747,0,0,1,26.2,28.4ZM8.4,16.9v.2a7.553,7.553,0,0,1-2.8-5.8,7.5,7.5,0,1,1,15,0v1a2.862,2.862,0,0,1-2.8,2.8h-.5a3.7,3.7,0,0,0-3.2-1.9H12.2A3.653,3.653,0,0,0,8.4,16.9Z",
    fill: "#625f5a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9,12.2v-.9a11.2,11.2,0,1,1,22.4-.1v.9a6.594,6.594,0,0,1-6.6,6.6H12.1a1.9,1.9,0,0,1,0-3.8H14a1.9,1.9,0,0,1,1.9,1.9h1.9a4.7,4.7,0,0,0,4.7-4.7v-.9a9.4,9.4,0,1,0-18.8,0v.9a.9.9,0,0,1-.9.9A.765.765,0,0,1,1.9,12.2Z",
    className: "altColourFill",
    fill: "#625f5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.9e0b097d.svg";
export { ForwardRef as ReactComponent };